var map = {
	"./3ds.png": "5663",
	"./arrow-down.svg": "896a",
	"./arrow-left.svg": "857e",
	"./arrow-right.svg": "50c3",
	"./audio/background-music.mp3": "6770",
	"./back.svg": "ccfe",
	"./bottomBg.webp": "dbfe",
	"./chat.svg": "5f66",
	"./check-mark.svg": "57ad",
	"./check.svg": "f222",
	"./chest.png": "da0f",
	"./choose.svg": "bccc",
	"./clarna.svg": "45c8",
	"./close.svg": "bf37",
	"./coin.svg": "8861",
	"./delete.svg": "d739",
	"./eye.svg": "83a4",
	"./fillter.svg": "9d50",
	"./google.svg": "0895",
	"./gray-bg.png": "7c0b",
	"./hero.png": "b5e0",
	"./hero.webp": "fc05",
	"./heroBg.webp": "3bf1",
	"./insta.svg": "598a",
	"./key.svg": "07f4",
	"./logo-mini.svg": "d595",
	"./logo.svg": "9b19",
	"./mail.svg": "1752",
	"./mastercard.svg": "2112",
	"./mbway.svg": "092e",
	"./multibanco.svg": "95b2",
	"./next-disabled.svg": "2655",
	"./next.svg": "b2f3",
	"./offer.svg": "d420",
	"./optionBg.png": "2482",
	"./pagNext.svg": "b662",
	"./product.png": "8cc9",
	"./right-arrow.svg": "f590",
	"./safe-bg.png": "0efa",
	"./safe-left-bottom.png": "a71d",
	"./safe.webp": "4028",
	"./textBg.webp": "cdf6",
	"./user.svg": "0f62",
	"./video/hero-video.mp4": "789f",
	"./visa.svg": "0239",
	"./wallet.svg": "bc38",
	"./why-1.webp": "dcd8",
	"./why-2.webp": "10b0",
	"./why-3.webp": "5e93",
	"./why-bg.png": "93bf",
	"./why-us-1.webp": "8d34",
	"./why-us-2.webp": "cff1",
	"./why-us-3.webp": "d80d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";